module.exports = __webpack_public_path__ + "static/media/property-managers-8.2f33d037.svg";